<template>
  <div class="row list-avaliacoes">
    <div class="container-fluid">
      <h4 class="title">AVALIAÇÕES</h4>
      <small>Veja abaixo as avaliações realizadas no ciclo de {{ !!myDefaultEvaluationCycleYear ? myDefaultEvaluationCycleYear : cycleYear }}.</small><br/><br/>
      <div class="row">
        <div class="col-lg-12 col-md-12">
          <div class="row">
            <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-6">
              <div class="form-group">
                <select v-model="myDefaultEvaluationCycleYear" class="form-control">
                  <option value="">Ciclo</option>
                  <option v-for="evaluationCycle in evaluationCycles" :value="evaluationCycle.year" :key="`cycle-${evaluationCycle.id}`">{{ evaluationCycle.name }}</option>
                </select>          
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12" v-for="evaluation in myEvaluations" :key="evaluation.id">
          <div class="card">
            <div class="card-content text-center">
              <div class="row">
                <div class="col-xs-6">
                  <div class="numbers pull-left date_evaluation">
                    <span>
                      <b>{{ evaluation.cycle_name }}</b><br/>{{ evaluationTypeTranslate(evaluation.type) }}
                    </span><br/><small>{{ evaluation.start_date | formatDate }} a {{ evaluation.end_date | formatDate }}</small>
                  </div>
                </div>
                <div class="col-xs-6">
                  <div class="pull-right" v-if="evaluation.type == 1">                    
                    <span class="label label-warning" @click="evaluationInfo()" v-if="!evaluation.status">
                      PENDENTE
                    </span>
                    <router-link :to="`resultado/${evaluation.id}`" v-else>
                      <span class="label label-success">
                        CONCLUÍDA
                      </span>
                    </router-link>
                  </div>
                  <div class="pull-right" v-if="evaluation.type == 3">                    
                    <span class="label label-info" @click="toEvaluate(evaluation)" v-if="!evaluation.status">
                      <i class="ti-check"></i> AUTOAVALIAR
                    </span>
                    <router-link :to="`resultado/${evaluation.id}`" v-else>
                      <span class="label label-success">
                        CONCLUÍDA
                      </span>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-12 col-md-12" v-if="myEvaluations.length == 0">
          <div class="card">
            <div class="card-content">
              <p class="category text-center">Sem avaliações</p>
            </div>
          </div>
        </div>  
      </div>     
    </div>
  </div>
</template>
<script>
  import swal from 'sweetalert2'
  import moment from 'moment'

  export default {
    mounted () {
      this.cycleYear = moment.utc().format('YYYY')
      this.getEvaluationCycles()
      this.getDefaultEvaluations(this.cycleYear)
    },
    data () {
      return {
        cycleYear: '',
        evaluationCycles: [],
        myEvaluations: [],
        myDefaultEvaluationCycleYear: ''
      }
    },
    filters: {
      formatDate (date) {
        return moment(date).format('DD/MM/YYYY')
      }
    },
    methods: {
      getEvaluationCycles () {
        let url = '/collaborator/evaluation-cycle'
        axios.get(url)
        .then((response) => {
          this.evaluationCycles = response.data
        }).catch((error) => {
          console.log(error)
        })
      },
      getDefaultEvaluations (year = null) {
        let url = '/collaborator/my-evaluations'

        if (year) {
          url += `?cycle=${year}`
        }

        axios.get(url)
        .then((response) => {
          this.myEvaluations = response.data
        }).catch((error) => {
          console.log(error)
        })
      },
      evaluationInfo () {
        swal({
          title: 'Avaliação Pendente',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          html: 'Essa Avaliação ainda não foi realizada pelo gestor imediato '
        })
      },
      evaluationTypeTranslate (typeId) {
        switch (typeId) {
          case 1:
            return 'Av. de Desempenho'
          case 2:
            return 'Me avalia aí'
          case 3:
            return 'Autoavaliação'
          default:
            break
        }
      },
      toEvaluate (evaluation) {
        const evaluationId = evaluation.id
        swal({
          title: 'Você tem certeza!',
          text: 'Você iniciará avaliação agora.',
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          confirmButtonText: 'OK',
          buttonsStyling: false,
          preConfirm: res => {
            return this.verifyAccess(evaluationId).catch(error => {
              let message =
                'Não foi possível completa requisição, tente novamente mais tarde.'
              if (error.response.status !== 500) {
                message = error.response.data.error
              }

              swal.showValidationError(message)

              return new Promise((resolve, reject) => {
                reject(new Error(message))
              })
            })
          }
        }).then(res => {
          this.execEvaluation(evaluationId, res.data)
        })
      },
      verifyAccess (evaluationId) {
        return axios.post('/collaborator/manager/verify-access-evaluation', {
          evaluation_id: evaluationId
        })
      },
      execEvaluation (evaluationId, dataAccess) {
        swal({
          title: 'Acesso Liberado!',
          html: 'Link de validação gerado. <br/> <small>Você tem 72 horas para realizar avaliação com o link gerado.</small>',
          type: 'success',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-danger btn-fill',
          cancelButtonText: 'Cancelar',
          confirmButtonText: 'Acessar Avaliação',
          buttonsStyling: false,
          preConfirm: () => {
            if (dataAccess.access_token) {
              return new Promise((resolve, reject) => {
                resolve(dataAccess)
              })
            }

            return new Promise((resolve, reject) => {
              reject(new Error('Token não pode ser encontrado.'))
            })
          }
        })
        .then(res => {
          const collaboratorId = JSON.parse(localStorage.getItem('user')).id
          this.$router.push(`/avaliacao/formulario/${collaboratorId}/${evaluationId}/${res.access_token}`)
        })
        .catch(swal.noop)
      }
    },
    watch: {
      myDefaultEvaluationCycleYear (value) {
        this.getDefaultEvaluations(value)
      }
    }
  }

</script>
<style>
.main-panel > .content {
    padding: 30px 15px 0 15px;
    min-height: calc(100% - 186px);
}
.label {
    padding: 8px 13px;
    border-radius: 30px;
    font-size: .95em !important;
}
.card .pull-right .label {
    margin-top: 16px !important;
}
.label-warning, .label-info {
  cursor: pointer;
}
.date_evaluation{
  font-size:1em !important;
}
.card .card-content {
    padding: 8px 15px 12px 15px;
}
.swal2-modal .swal2-content {
    font-size: 15px;
}
.swal2-confirm{
  margin-right:10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Evaluation/List.vue